import paronApi from '@/utils/paron-api'

export default {
    getAllCourts(page = 1, perPage = 60) {
        return paronApi.get(`court/all?page=${page}&per_page=${perPage}`)
    },

    getCourtById(id) {
        return paronApi.get(`court/${id}`)
    },

    createCourt(data) {
        return paronApi.uploadFile('court/new', data)
    },

    editCourtById(id, data) {
        return paronApi.uploadFile(`court/${id}/edit`, data)
    },

    deleteCourtById(id) {
        return paronApi.delete(`court/${id}`)
    }

}
